import ProgressBar from 'progressbar.js';

export const progressCircle = ({
    node,
    value,
    total,
    countDown,
    units,
}) => {

    const bar = new ProgressBar.Circle(node, {
        color: '#EF6E0B',
        trailColor: '#D7D2CB',
        strokeWidth: 6,
        trailWidth: 6,
        text: {
            className: 'progressbar__label',
            style: null,
        },
        from: { color: '#F8A71A' },
        to: { color: '#EF6E0B' },
        step(state, circle) {

            // Animate colour change
            circle.path.setAttribute('stroke', state.color);

            // If value is great than total, dont show overflow
            if (circle.value() > 1) {
                circle.trail.setAttribute('stroke', '#EF6E0B');
                circle.path.setAttribute('stroke', '#EF6E0B');
            }

            let stepValue;
            if (countDown) {
                stepValue = Math.round(total - circle.value() * total);
            } else {
                stepValue = Math.round(circle.value() * total);
            }

            let displayedStepValue = stepValue;

            // Countdown
            if (countDown) {
                if (stepValue === 0) node.classList.add('progressbar--warning');
            } else {
                // Count up (points)
                const result = Number(total);
                if (stepValue > result) {
                    node.classList.remove('progressbar--complete');
                    node.classList.add('progressbar--overflow');
                    circle._container.dataset.overflow = `+${stepValue - result}`; // eslint-disable-line no-underscore-dangle
                } else if (stepValue === result) {
                    node.classList.add('progressbar--complete');
                }

                displayedStepValue = stepValue > result ? result : stepValue;
            }

            circle.setText(`<strong class="h1">${displayedStepValue}</strong> <span class="small semi">${units}</span>`);

        },
    });

    bar.path.style.strokeLinecap = 'round';

    if (countDown) {
        bar.animate(1 - value / total);
    } else {
        bar.animate(value / total);
    }

    return bar;
};

export const progressLine = ({
    node,
    value,
    total,
    countDown,
}) => {

    if (value === total) node.classList.add('progressbar--complete');

    const linearGradient = `
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="userSpaceOnUse">
          <stop offset="20%" stop-color="#FFA000"/>
          <stop offset="50%" stop-color="#EF6E0B"/>
        </linearGradient>
      </defs>
    `;

    const bar = new ProgressBar.Line(node, {
        color: 'url(#gradient)',
        strokeWidth: 1,
        trailWidth: 1,
        text: null,
        svgStyle: { width: '100%', height: '12px' },
    });
    // append the linearGradient to svg
    bar.svg.insertAdjacentHTML('afterBegin', linearGradient);

    bar.path.style.strokeLinecap = 'round';

    if (countDown) {
        bar.animate(1 - value / total);
    } else {
        bar.animate(value / total);
    }

    return bar;
};


export default (() => {
    const circles = Array.from(document.querySelectorAll('.progressbar[data-type="circle"]'));
    const lines = Array.from(document.querySelectorAll('.progressbar[data-type="line"]'));

    circles.forEach((circle) => {
        progressCircle({
            node: circle,
            value: circle.dataset.value,
            total: circle.dataset.total,
            countDown: circle.dataset.countDown,
            units: circle.dataset.units,
        });
    });

    lines.forEach((line) => {
        progressLine({
            node: line,
            value: line.dataset.value,
            total: line.dataset.total,
            countDown: line.dataset.countDown,
            units: line.dataset.units,
        });
    });
})();
